const Textarea = {
  baseStyle: {
    _disabled: {
      bgColor: "#F4F5F5",
      color: "#6A7171",
      cursor: "not-allowed",
      opacity: 1,
      border: "1px solid #C0C4C4",
    },
  },
  variants: {
    filled: {
      bgColor: "white",
      _focus: {
        bgColor: "white",
      },
    },
    outline: {
      borderColor: "#c2c4cc",
      borderRadius: 'md',
      fontSize: '14px',
      _focus: {
        borderColor: "primary",
        boxShadow: "none",
      },
      _invalid: {
        boxShadow: "none",
        _focus: {
          borderColor: "#E53E3E",
        },
      },
    },
  },
};

export default Textarea;
